import { put, takeEvery } from 'redux-saga/effects';
import { API } from '@factorin/container.macro';

import { apiCall } from 'Modules/core/api';
import { messagingActions } from 'Modules/core/messaging';

import { storageActions } from './actions';


export function* loadStorageItem({ path, $payload: id }) {
    try {
        const item = yield apiCall(API.domain[path].item, { id });
        yield put(storageActions.receive(path, { [id]: item }));
        return item;
    } catch (err) {
        yield put(storageActions.setError(path, { id, error: `${err}` }));
        yield put(
            messagingActions.showNotification({
                content: 'storage.getError',
            }),
        );
        return null;
    }
}

export function* saveStorageItem({ path, $payload: { id, item } }) {
    try {
        yield apiCall(API.domain[path].update, { id, item });
        const updated = { ...item };
        yield put(storageActions.receive(path, { [id]: updated }));
        return updated;
    } catch (err) {
        yield put(storageActions.setError(path, { id, error: `${err}` }));
        yield put(
            messagingActions.showNotification({
                content: 'storage.saveError',
            }),
        );
        return null;
    }
}

export function* initializeStorage() {
    yield put(storageActions.initialize());
}

export const sagas = [
    takeEvery(`${storageActions.loadItem}`, loadStorageItem),
    takeEvery(`${storageActions.saveItem}`, saveStorageItem),
];
